module.exports = __webpack_public_path__ + "Flama-BlackItalic.woff?1ea6b7d3146e2a1b2b25c8c8f8d7f9bf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BlackItalic.woff
// module id = 909
// module chunks = 0